import Brett from "./Brett";

export default class Rueckwand {

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    box = new THREE.Box3();
    object3d: ?THREE.Object3D;
    product: Object;
    walls: Array;
    element: Element;

    constructor(schrank) {
        this.schrank = schrank;
        this.product = Rueckwand.findProduct();
        this.mainAxes = 'yx';
    }

    static findProduct() {
        return APP.findProduct(`Rueckwand-{APP.arrangement.Modell.Name}`) || APP.findProduct('Rueckwand');
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

    get parent() {
        return this.arrangement;
    }

    compile() {
        this.box = this.schrank.elementsBox.clone();
        this.box.max.z = this.schrank.rueckwandInnerZOffset;
        this.box.min.z = this.schrank.rueckwandOuterZOffset;

        this._compileChildren();
    }

    _compileChildren() {
        const lazyWalls = APP.model.lazyPool(this, 'walls', () => new Brett(this.schrank, this.product.Artikelnummer, this.mainAxes));
        const createWand = (box, element = null) => {
            const nextWall = () => {
                const wall = lazyWalls.next();
                if (element) {
                    element.rueckwand.push(wall);
                }
                return wall;
            };
            if (this.schrank.angleSide === 'back') {
                const wandUnten = nextWall();
                wandUnten.box = box.clone();
                wandUnten.box.min.z = this.box.min.z;
                wandUnten.box.max.z = this.box.max.z;
                wandUnten.box.max.y = this.schrank.slopings.yOfZ(this.box.min.z,0);
                wandUnten.boxToVertices();
                wandUnten.updateBox();
            } else {
                const wand = nextWall();
                wand.box = box.clone();
                wand.box.min.z = this.box.min.z;
                wand.box.max.z = this.box.max.z;
                const brettstaerke = APP.settings.getFloat('brett_staerke') / 2;
                if (this.schrank.slopings.isSloped(wand.box)) {
                    wand.box.max.y = Math.min(this.schrank.slopings.yOfX(wand.box.max.x, brettstaerke), wand.box.max.y);
                    wand.boxToVertices();
                    wand.zEdgeXY(0, 1).y = this.schrank.slopings.yOfX(wand.box.min.x, brettstaerke);
                    if (this.schrank.slopings.isBroken(wand.box)) {
                        wand.zEdgeXY(2, 1)._ = {x: this.schrank.slopeX, y: this.box.max.y + brettstaerke};
                    }
                    wand.updateBox();
                } else {
                    wand.boxToVertices();
                }
            }
        };

        if (APP.settings.getBool('rueckwand_ist_verbundartikel')) {
            createWand(this.box);
        } else {
            this.schrank.elements.forEach(element => {
                element.rueckwand = [];
                createWand(element.box, element)
            });
        }
        lazyWalls.cleanup();

        this.walls.forEach(x => x.compile());
    }

    get flaechenMass() {
        const result = new THREE.Vector3(0, 0, 0);
        this.walls.forEach(boden => {
            result.x += boden.flaechenMass.x;
            result.y = Math.max(result.y, boden.flaechenMass.y);
            result.z = Math.max(result.z, boden.flaechenMass.z)
        });
        return result;
    }

    get materialArtikelnummer() {
        return this.walls[0].materialArtikelnummer;
    }

    get size() {
        return this.flaechenMass;
    }

    iterate(iterator) {
        iterator(this);
    }

}
